import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideMemberOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="要員管理"
      description="社員・社外要員の登録・更新・削除を行う管理機能です。パートナーとの紐付けや契約形態の管理を行います。管理者・管理部門・課長が操作可能です。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="member/register-employee">社員を登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              自社の社員を要員として登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="member/register-external">社外要員を登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              パートナー企業の社外要員を登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="member/bulk-register">要員を一括登録する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              CSVファイルを使用して複数の要員を一括で登録します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="member/update">要員情報を更新する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              既存の要員情報を更新します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="member/delete">要員を削除する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              不要になった要員を削除します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="member/search">要員を検索する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              条件を指定して要員を検索・絞り込みます。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="member/detail">要員の詳細情報を確認する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              要員の登録情報を詳細画面で確認します。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideMemberOverview;
